import { render } from "./CoursesForCompaniesAndInstitutions.vue?vue&type=template&id=6166dd05&scoped=true"
import script from "./CoursesForCompaniesAndInstitutions.vue?vue&type=script&lang=js"
export * from "./CoursesForCompaniesAndInstitutions.vue?vue&type=script&lang=js"

import "./CoursesForCompaniesAndInstitutions.vue?vue&type=style&index=0&id=6166dd05&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6166dd05"]])

export default __exports__